import React, { useState, useEffect } from 'react'

import Swiper from 'react-id-swiper'

import ImgPessoa from 'images/quem-somos/colaboradores-01.png'
import ImgPessoa02 from 'images/quem-somos/colaboradores-02.png'
import ImgPessoa03 from 'images/quem-somos/colaboradores-03.png'
import ImgPessoa04 from 'images/quem-somos/colaboradores-04.png'
import ImgPessoa05 from 'images/quem-somos/colaboradores-05.png'
import ImgPessoa06 from 'images/quem-somos/colaboradores-06.png'
import ImgPessoa07 from 'images/quem-somos/colaboradores-07.png'

import ArrowPrev from 'images/arrow-prev-slide-pessoas.svg'
import ArrowNext from 'images/arrow-next-slide-pessoas.svg'

const Gallery = () => {
  const [gallerySwiper, getGallerySwiper] = useState(null)
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null)

  const goNext = () => {
    if (gallerySwiper !== null) {
      gallerySwiper.slideNext()
    }
  }
  const goPrev = () => {
    if (gallerySwiper !== null) {
      gallerySwiper.slidePrev()
    }
  }

  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    preloadImages: false,
    pagination: {
      el: '.s-pessoas .ctrl-slide .swiper-pagination',
      clickable: true,
    },
  }

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 23,
    preloadImages: false,
    touchRatio: 0.2,
    centeredSlides: true,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
  }

  useEffect(() => {
    if (gallerySwiper !== null && gallerySwiper.controller && thumbnailSwiper !== null && thumbnailSwiper.controller) {
      gallerySwiper.controller.control = thumbnailSwiper
      thumbnailSwiper.controller.control = gallerySwiper
    }
  }, [gallerySwiper, thumbnailSwiper])

  return (
    <div>
      <div>
        <Swiper {...gallerySwiperParams}>
          <div className="swiper-slide">
            <img src={ImgPessoa} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa02} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa03} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa04} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa05} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa06} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa07} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
        </Swiper>
        <Swiper {...thumbnailSwiperParams}>
          <div className="swiper-slide">
            <img src={ImgPessoa} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa02} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa03} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa04} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa05} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa06} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
          <div className="swiper-slide">
            <img src={ImgPessoa07} alt="Foto de Colaboradores da Precisão Sistemas" />
          </div>
        </Swiper>
      </div>
      <div className="ctrl-slide">
        <div className="btns">
          <button onClick={goPrev} className="btn btn-prev">
            <img src={ArrowPrev} alt="Icone seta voltar" />
          </button>
          <button onClick={goNext} className="btn btn-next">
            <img src={ArrowNext} alt="Icone seta avançar" />
          </button>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </div>
  )
}

export default Gallery
